import { useFonts } from 'hooks/queries/workspaces/useFonts'
import { useEffect } from 'react'
import { FONT_WEIGHTS } from 'components/VisualStudioPlayground/Shapes/TextBoxShape/constants'
import { FontWeightType } from 'components/VisualStudioPlayground/VisualEditor/Types'
import { Font } from 'types'

export const fontWeight = (font: Font) => {
  const weight = Object.keys(FONT_WEIGHTS).find(
    (key) => FONT_WEIGHTS[parseInt(key) as FontWeightType] === font.font_subfamily,
  )

  return (weight ? parseInt(weight) : 400) as FontWeightType
}

export const CustomFontsLoader = () => {
  const { data } = useFonts({ cacheTime: 1000 * 60 * 5 })

  useEffect(() => {
    if (data) {
      const { fonts } = data
      fonts.forEach(async (font) => {
        const weight = fontWeight(font)
        const fontFace = new FontFace(font.name, `url(${font.source_url})`, { weight: weight.toString() })
        document.fonts.add(fontFace)
        fontFace.load()
      })
    }
  }, [data])

  return null
}
